module.exports = __webpack_public_path__ + "static/media/icon_news_a.25cad6ca.svg";